/**
 * Error Handling Module - Centralized Export
 * Provides clean imports for all error handling functionality
 */

// Re-export everything from consolidated module
export * from './consolidated';

// Re-export specific types for easy access
export type {
  ErrorResponse,
  SuccessResponse,
  ApiResponse,
  AuthError,
  BatchResult
} from './consolidated';

// Re-export enums for easy access
export { ErrorType } from './consolidated'; 
